import { useClaims } from '@lmt/unicorn-shared/app/features/auth/operations';
import React, { FC } from 'react';

export interface Props {
  children?: React.ReactNode;
}

export const DeveloperMode: FC<Props> = (props) => {
  const claims = useClaims();

  return <>{claims.permissions.developerMode && props.children}</>;
};
